export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9888.12f8e44e.jpg";